<div class="acct dropdown">
  <button type="button" class="acct__btn" id="accountMenu" data-bs-toggle="dropdown" aria-expanded="false">
    <img *ngIf="user?.photo" [src]="user.photo" alt="" class="acct__avatar">
    <span *ngIf="!user?.photo" class="acct__avatar acct__avatar--initials">{{ initials }}</span>
    <span *ngIf="showName" class="acct__id">
      <span class="acct__name">{{ user.first_name }} {{ user.last_name }}</span>
      <span class="acct__email">{{ user.email }}</span>
    </span>
  </button>
  <ul class="dropdown-menu dropdown-menu-end dropdown-user" aria-labelledby="accountMenu">
    <li>
      <div class="dropdown-item">
        <div class="user-img" *ngIf="user.photo"><img src="{{user.photo}}" alt="user" class="rounded-circle" /></div>
        <div class="d-inline-block">
          <h4>{{ user.first_name }} {{ user.last_name }}</h4>
          <p class="text-muted">{{ user.email }}</p>
          <a href="javascript:void(0)" class="close-btn" title="close"><i class="fa fa-close"></i></a>
        </div>
      </div>
    </li>
    <li><hr class="dropdown-divider"></li>
    <li><a class="dropdown-item" routerLink="/my/profile" title="Account Setting"><i class="ti-settings"></i> Account Setting</a></li>
    <li *ngIf="sandboxUrl">
      <a class="dropdown-item" [href]="sandboxUrl" target="_blank" rel="noopener"
        title="Opens the sandbox in a new tab. It is a separate site: sign in again with your usual password.">
        <i class="fa fa-flask"></i> Go to Sandbox
      </a>
    </li>
    <li><hr class="dropdown-divider"></li>
    <li *ngIf="user.staff_id">
      <a (click)="onShadow()" href="javascript:void(0);" class="dropdown-item" [ngClass]="{'text-danger': user.shadowed, 'text-info': !user.shadowed}">
        <i class="ti-hand-point-right"></i>&nbsp;<ng-template [ngIf]="!user.shadowed">Activate</ng-template><ng-template [ngIf]="user.shadowed">Deactivate</ng-template> Shadow Schedule
      </a>
    </li>
    <li *ngIf="user.staff_id"><hr class="dropdown-divider"></li>
    <li><a class="dropdown-item" href="javascript:void(0)" (click)="onLogout()" title="Logout"><i class="fa fa-power-off"></i> Logout</a></li>
  </ul>
</div>
